"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTRACT_EXPIRY_GRACE = exports.isContractType = exports.ContractType = exports.mapping = exports.MIN_SERIVCE_LEVEL_FOR_PREMIUM = exports.SERVICE_LEVEL_DEFAULT = exports.SERVICE_LEVEL_FREE_DESIGNS_LIMIT = exports.SERVICE_LEVEL_ENTERPRISE = exports.SERVICE_LEVEL_ENHANCED = exports.SERVICE_LEVEL_BASIC = exports.SERVICE_LEVEL_FREE = void 0;
exports.SERVICE_LEVEL_FREE = 0;
exports.SERVICE_LEVEL_BASIC = 1;
exports.SERVICE_LEVEL_ENHANCED = 2;
exports.SERVICE_LEVEL_ENTERPRISE = 3;
exports.SERVICE_LEVEL_FREE_DESIGNS_LIMIT = 100;
exports.SERVICE_LEVEL_DEFAULT = exports.SERVICE_LEVEL_ENTERPRISE;
exports.MIN_SERIVCE_LEVEL_FOR_PREMIUM = exports.SERVICE_LEVEL_BASIC;
exports.mapping = {
    "Basic Service": exports.SERVICE_LEVEL_BASIC,
    "Enhanced Service": exports.SERVICE_LEVEL_ENHANCED,
    "Design Service": exports.SERVICE_LEVEL_ENHANCED,
    "Enterprise Service": exports.SERVICE_LEVEL_ENTERPRISE,
    Event: exports.SERVICE_LEVEL_ENHANCED,
    "Legacy Contract Item": exports.SERVICE_LEVEL_ENHANCED,
    "Mobility Service": exports.SERVICE_LEVEL_ENHANCED,
    "SRV COFFEE": exports.SERVICE_LEVEL_ENHANCED,
    "SRV COFFEE SUB": exports.SERVICE_LEVEL_ENHANCED,
    "SRV MOBILITY": exports.SERVICE_LEVEL_ENHANCED,
    "Ripple Maker Lease": exports.SERVICE_LEVEL_ENHANCED,
    "No Service": exports.SERVICE_LEVEL_FREE,
};
var ContractType;
(function (ContractType) {
    ContractType["BASIC_SERVICE"] = "Basic Service";
    ContractType["ENHANCED_SERVICE"] = "Enhanced Service";
    ContractType["DESIGN_SERVICE"] = "Design Service";
    ContractType["ENTERPRISE_SERVICE"] = "Enterprise Service";
})(ContractType = exports.ContractType || (exports.ContractType = {}));
function isContractType(value) {
    var contractTypes = [];
    for (var key in ContractType) {
        if (ContractType.hasOwnProperty(key)) {
            contractTypes.push(ContractType[key]);
        }
    }
    return contractTypes.indexOf(value) !== -1;
}
exports.isContractType = isContractType;
exports.CONTRACT_EXPIRY_GRACE = 172800; // 2 days
//# sourceMappingURL=config.js.map